const routesPaths = {
  index: '/',
  rules: '/rules',
};

export default routesPaths;
